// The colour of a marble box. None means the grid cell is empty (no box).
// Names match the art export (Red01Ball.png -> Red01), since the lowercased name IS the game sprite's
// Addressable key suffix. The one exception is Purple, whose art still exports as Purple02*.png.
//
// Values are explicit and permanent — a level file carries these numbers, so a value may never be
// reused for a different colour. They are NOT the palette order: that is BOX_COLORS below, and the two
// stopped agreeing when the palette was reordered. To go from "palette slot i" to a colour, index
// BOX_COLORS; `i + 1` is the enum, which is a different question.
//
// Levels serialise colours as these numbers, so renumbering rewrites the meaning of existing level data.
// That happened once, when the two purples merged into one and the trailing colours closed up behind the
// retired slot; levels compiled before that need regenerating.
export var MarbleColor;
(function (MarbleColor) {
    MarbleColor[MarbleColor["None"] = 0] = "None";
    MarbleColor[MarbleColor["Red01"] = 1] = "Red01";
    MarbleColor[MarbleColor["Green01"] = 2] = "Green01";
    MarbleColor[MarbleColor["Blue01"] = 3] = "Blue01";
    MarbleColor[MarbleColor["Blue02"] = 4] = "Blue02";
    MarbleColor[MarbleColor["Yellow01"] = 5] = "Yellow01";
    MarbleColor[MarbleColor["Purple"] = 6] = "Purple";
    MarbleColor[MarbleColor["Pink"] = 7] = "Pink";
    MarbleColor[MarbleColor["Green02"] = 8] = "Green02";
    MarbleColor[MarbleColor["Green03"] = 9] = "Green03";
    MarbleColor[MarbleColor["Orange"] = 10] = "Orange";
    MarbleColor[MarbleColor["Brown"] = 11] = "Brown";
    MarbleColor[MarbleColor["Black"] = 12] = "Black";
    MarbleColor[MarbleColor["White"] = 13] = "White";
})(MarbleColor || (MarbleColor = {}));
// The compiler's shopping list. A level names a COUNT, not colours: `paletteSize: N` gets the first N
// entries of the palette, and every one of them is guaranteed to appear. So the order alone decides what
// a low-palette level shows, and — because most levels ask for a small N — how much of the game each
// colour is seen in at all. Mirrors MarblePalette.BoxColors (Gameplay/LevelData.cs); keep them in step.
//
// Since colour presets (Settings → Colour Presets), this array is the FALLBACK order, not the law: the
// order compiles actually deal from is the selected preset, served by the backend and mirrored client-side
// by paletteStore (this array = the seeded read-only "Default" preset). Anything that shows palette SLOTS
// must read paletteStore.colors; this constant remains for the colour SET and for offline fallback.
export const BOX_COLORS = [
    MarbleColor.Red01,
    MarbleColor.Green01,
    MarbleColor.Blue02,
    MarbleColor.Yellow01,
    MarbleColor.Purple,
    MarbleColor.Black,
    MarbleColor.White,
    MarbleColor.Brown,
    MarbleColor.Green03,
    MarbleColor.Pink,
    MarbleColor.Orange,
    MarbleColor.Blue01,
    MarbleColor.Green02,
];
// Balls each box drops (MarbleBox lays them out 3x3). Slices mirror these so every ball has a slot.
export const BALLS_PER_BOX = 9;
